import StatusBar from './statusBar';

export default StatusBar